import * as React from "react";
import ContentLoader from "react-content-loader";


export const WorkkardListingHeaderLoader = props =>{
        return(<>
      {props.count && props.count > 0 && (
                    Array.from({ length: props.count }, (_, i) => (
            <ContentLoader 
            speed={2}
            key={i+1}
            width={1000}
            height={22}
            viewBox="0 0 969 19"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
            >
            <rect x="5" y="5" rx="8" ry="8" width="80" height="8"></rect>
            <rect x="160" y="5" rx="8" ry="8" width="80" height="8"></rect>
            <rect x="326" y="5" rx="8" ry="8" width="80" height="8"></rect>
            <rect x="584" y="5" rx="8" ry="8" width="80" height="8"></rect>
            <rect x="829" y="5" rx="8" ry="8" width="80" height="8"></rect>
        </ContentLoader>
                    ))
                )}</>)
}